<button class="action-button" mat-flat-button [routerLink]="subpage || null"
	(click)="clickAction ? clickAction() : null" [disabled]="disabled">
	<span *ngIf="!!icon" [ngClass]="badge.hasBadge ? 
		'icon-container mat-badge mat-badge-overlap mat-badge-above mat-badge-before mat-badge-medium' 
		: 'icon-container'">
		<span *ngIf="badge.hasBadge" class="mat-badge-content mat-badge-active badge-content">{{badge.value}}</span>
		<img [src]="'../../../../assets/images/buttons/' + icon" />
	</span>
	<span class="text-container">{{ name }}</span>
</button>